<template>
  <v-main id="mainCheckout" class="mainCheckout">
    <v-row
      class="px-6 pb-3 pt-0"
      style="align-self: center !important; font-weight: bolder; color: #e30011"
    >
      <v-icon class="pr-2" @click="$router.go(-1)" color="#E30011"
        >mdi-arrow-left</v-icon
      >

      <div @click="$router.go(-1)" style="align-self: center; cursor: pointer">
        <span v-if="!breadcrumbs">voltar para gestão de pedidos</span>
        <span v-if="breadcrumbs">voltar para detalhar revenda</span>
      </div>
    </v-row>

    <v-card class="d-flex align-center ma-0 pa-0" elevation="0">
      <div class="px-4" style="width: 100%">
        <div class="d-flex">
          <div class="pedido-numero">
            Pedido <b>{{ this.pedido.orderCode }}</b>
          </div>

          <v-spacer></v-spacer>

          <v-btn outlined fab tile small class="mt-4" @click="excel">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </div>
        <div class="swiper-container">
          <p class="swiper-control"></p>
          <div class="swiper-wrapper timeline">
            <div class="swiper-slide" v-for="(item, idx) in steps" :key="idx">
              <div class="status">
                <span class="status-title">{{ item.title }}</span>
                <span class="date">{{ item.dateLabel }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-end pb-3">
          <v-btn
              class="secondary-button"
              elevation="0"
              @click="separarDialog = true"
          >
            Pedido em separação
          </v-btn>

          <v-btn
              class="secondary-button"
              elevation="0"
              @click="enviarDialog = true"
          >
            Pedido enviado
          </v-btn>

          <v-btn
              class="secondary-button"
              elevation="0"
              @click="entregarDialog = true"
          >
            Pedido entregue
          </v-btn>

          <v-btn
              class="secondary-button"
              elevation="0"
              @click="cancelareDialog = true"
          >
            Cancelar pedido
          </v-btn>

          <v-btn
              class="secondary-button"
              elevation="0"
              @click="devolverDialog = true"
          >
            Pedido devolvido
          </v-btn>
        </div>
      </div>
    </v-card>

    <!-- Linha 1 -->
    <v-row class=" pa-5 py-1 pa mx-3" v-if="itemsCancelled && itemsCancelled.length > 0">
      <v-expansion-panels
           style="background: rgba(255, 165, 0, 0.5)"
           class="mb-4 elevation-0"
      >
        <v-expansion-panel>
          <v-expansion-panel-header style="height: 70px" color="rgba(255, 165, 0, 0.5)">
            <section class="d-flex align-center">
              <v-icon size="40" color="#bc0000">
                mdi-alert-circle-outline
              </v-icon>

              <h2 style="color: #bc0000">Atenção: Alguns itens desse pedido foram cancelados, clique aqui para ver os itens.</h2>
            </section>
            <template v-slot:actions>
              <v-icon size="40">
                mdi-chevron-down
              </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row cols="12" class="pa-0 ma-0">
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pa-0 ma-0 mt-2 ">
                <div class="span-title pa-0 ma-0 px-5 py-2">Itens cancelados</div>
                <v-data-table
                    ref="table"
                    :loading="loading"
                    loading-text="Carregando..."
                    no-data-text="Nenhum pedido encontrado"
                    :headers="headersCancelled"
                    :items="itemsCancelled"
                    class="elevation-0"
                    hide-default-footer
                    :items-per-page="pageSize"
                    :header-props="headerProps"
                    :key="componentKey"
                >
                  <template v-slot:[`item.productSku`]="{ item }">
                    {{ item.productSku.attributes[0].name }}
                  </template>


                  <template v-slot:[`item.price`]="{ item }">
                    {{
                      item.price.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </template>

                  <template v-slot:[`item.priceOriginal`]="{ item }">
                    {{
                      item.productSku.differentValue.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </template>

                  <template v-slot:[`item.sub`]="{ item }">
                    {{
                      (item.qty * item.productSku.differentValue).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    {{
                      (item.qty * item.price).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </template>
                  <template v-slot:[`item.refundDate`]="{ item }">
                    {{
                      formatDate(item.refundDate)
                    }}
                  </template>
                </v-data-table>

                <v-divider class="mt-5"></v-divider>
                <p class="ml-3 mt-2"><strong>Motivo: </strong>{{pedido.descriptionOfCancellation && pedido.descriptionOfCancellation.length > 0? pedido.descriptionOfCancellation : '-'}}</p>
              </v-col>
            </v-row>

          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

    <v-row class="ma-0 pa-5 py-1 pa">
      <v-row class="cards ma-0 pa-0">
        <v-col xs="12" sm="12" md="12" lg="6" xl="6">
          <v-card class="cards ma-0 pa-0" style="height: auto !important">
            <div class="span-title pa-0 ma-0 px-5 py-2">
              Informações do Cliente
            </div>
            <div class="px-1 pt-1 py-2">
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td class="informacoes-cliente">Nome do cliente</td>
                      <td class="informacoes-cliente-dados">
                        {{ currentClient.name }}
                      </td>
                    </tr>

                    <tr>
                      <td class="informacoes-cliente">E-mail</td>
                      <td class="informacoes-cliente-dados">
                        {{ currentClient.email }}
                      </td>
                    </tr>

                    <tr>
                      <td class="informacoes-cliente">Telefone</td>
                      <td class="informacoes-cliente-dados">
                        <v-btn
                            v-if="currentClient && currentClient.phoneNumber && currentClient.phoneNumber.length > 0"
                            class="mx-2 icon_whatsapp mb-1"
                            :href="`https://api.whatsapp.com/send?1=pt_BR&phone=55${currentClient.phoneNumber.replace(/\D/g, '')}`"
                            target="_blank"
                            icon
                        >
                          <v-icon color="#25d366" size="28px">mdi-whatsapp</v-icon>
                        </v-btn>
                        {{
                          currentClient.phoneNumber
                            ? currentClient.phoneNumber
                            : "Sem registro"
                        }}
                      </td>
                    </tr>

                    <tr>
                      <td class="informacoes-cliente">CPF/CNPF</td>
                      <td class="informacoes-cliente-dados">
                        {{
                          currentClient.cnpj
                            ? currentClient.cnpj
                            : "Sem registro"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-card>
        </v-col>

        <v-col xs="12" sm="12" md="12" lg="6" xl="6">
          <v-card class="cards ma-0 pa-0" style="height: auto !important">
            <div class="span-title pa-0 ma-0 px-5 py-2">
              Endereço de entrega
            </div>
            <div style="min-height: 202px; padding-top: 10px" class="px-5">
              <div>
                <strong>{{ this.pedido.addressName }}</strong>
              </div>
              <div>
                {{ this.pedido.address }}
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Linha 2 -->
      <v-row class="cards ma-0 pa-0">
        <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
          <v-card
            class="cards ma-0 pa-0"
            style="min-height: 205px"
            height="100%"
          >
            <div class="span-title pa-0 ma-0 px-5 py-2">Revendedor</div>
            <v-row class="cards ma-0 pa-0">
              <v-col xs="12" sm="12" md="6" lg="6" xl="6">
                <v-img
                  v-if="currentResale.image"
                  class="image-container"
                  :src="showPhoto(this.currentResale.image)"
                  width="170"
                  height="127"
                >
                </v-img>
                <div
                  v-if="!currentResale.image"
                  class="revendedor-sem-foto d-flex flex-column align-center"
                >
                  <p class="text-revendedor-foto">Revendedor <br />sem foto</p>
                </div>
              </v-col>

              <v-col xs="12" sm="12" md="6" lg="6" xl="6">
                <div>
                  <span class="resale-name">{{ this.currentResale.name }}</span>
                  <br />
                  <span class="resale-endereco"
                    >{{ this.currentResale.city }},
                    {{ this.currentResale.state }}</span
                  >
                </div>

                <v-btn
                  elevation="0"
                  width="146"
                  height="40"
                  class="red-button"
                  @click="detailsDialog = true"
                >
                  Exibir perfil
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
          <v-card class="cards ma-0 pa-0" height="100%">
            <div class="span-title pa-0 ma-0 px-5 py-2">Total pago</div>
            <div class="px-1 pt-1 py-2">
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td class="total-pago">
                        <span>Subtotal (bruto)</span>
                        <br />
                        <span>Desconto</span>
                        <span v-if="pedido.coupon">
                          ({{pedido.coupon.code}})
                        </span>
                        <span v-if="!pedido.coupon && pedido.discount && Number(pedido.discount) > 0">
                          Promoção
                        </span>
                        <br />
                        <span>Frete</span>
                        <br />
                        <span>Comissão da plataforma</span>
                        <br />
                        <span>Taxa de transação</span>
                      </td>
                      <td class="total-pago-dados">
                        <span>{{
                          calculateSubtotal().toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</span>
                        <br />
                        <span>{{
                          pedido.discount.toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</span>
                        <br />
                        <span>{{
                          pedido.fretePrice.toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</span>
                        <br />
                        <span v-if="pedido && pedido.shipment && pedido.shipment.commission">{{
                            pedido.shipment.commission.toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</span>
                        <span v-else>{{
                            (0).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</span>
                        <br/>
                        <span >{{
                            (pedido.installmentsInterest + pedido.fees + pedido.processingCost).toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })
                          }}</span>
                      </td>
                    </tr>

                    <tr >
                      <td class="total-pago">Total líquido</td>
                      <td class="total-pago-dados">
                        {{
                          (
                              (pedido.totalPrice + pedido.fretePrice + pedido.installmentsInterest) - ((pedido && pedido.shipment &&  pedido.shipment.commission ? pedido.shipment.commission : 0) + pedido.fees + pedido.processingCost)
                          ).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" class="total-pago text-left pt-2">
                        <h4><strong>Legenda</strong></h4>
                        <div>
                          <strong>Taxa de processamento por boleto: {{
                              (3.49).toLocaleString("pt-br", {
                                style: "currency",
                                currency: "BRL",
                              })
                            }} </strong>
                        </div>
                        <div>
                          <strong>Taxa de processamento por pix: 1.19% </strong>
                        </div>
                        <div>
                          <strong>Taxa de processamento por cartão de crédito: {{
                              (0.99).toLocaleString("pt-br", {
                                style: "currency",
                                currency: "BRL",
                              })
                            }} </strong>
                        </div>
                        <div>
                          <strong>Parcelamento em 1x: 3.48% </strong><br/>
                          <strong>Parcelamento em 2x a 5x: 3.66% </strong><br/>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
          <v-card class="cards ma-0 pa-0" height="auto">
            <div class="span-title pa-0 ma-0 px-5 py-2">
              Informações da postagem
            </div>
            <div class="px-1 pt-1 py-2">
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                  <tr>
                    <td class="informacoes-cliente">Imprimir etiqueta</td>
                    <td class="informacoes-cliente-dados">
                      <span v-if="!pedido.linkToPrintLabel">Sem Registro</span>
                      <v-tooltip bottom v-if="pedido && pedido.etiquetaId">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              @click="getEtiquette()"
                              v-bind="attrs"
                              v-on="on"
                              icon
                          >
                            <v-icon size="23" color="#BC0000">mdi-printer</v-icon>
                          </v-btn>
                        </template>
                        <span >Imprimir etiqueta</span>
                      </v-tooltip>
                    </td>
                  </tr>

                  <tr>
                    <td class="informacoes-cliente">Codigo de postagem</td>
                    <td class="informacoes-cliente-dados">
                        <span v-if="pedido.trackingCode">
                          {{ pedido.trackingCode }}
                        </span>
                      <v-btn
                          v-else-if="
                            !pedido.trackingCode && pedido.linkToPrintLabel
                          "
                          class="ghost-buttons-outlined-black"
                          elevation="0"
                          width="130"
                          @click="inserirCodigoPostagemDialog = true"
                      >
                        Adicionar código
                      </v-btn>
                      <span v-else>Sem Registro</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="informacoes-cliente">Transportadora</td>
                    <td class="informacoes-cliente-dados">
                        <span v-if="pedido.companyName">{{
                            pedido.companyName
                          }}</span>
                      <span v-if="!pedido.companyName">Sem Registro</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="informacoes-cliente">Link para acompanhar</td>
                    <td class="informacoes-cliente-dados">
                      <a
                          v-if="pedido.trackingLink"
                          :href="pedido.trackingLink"
                          target="_blank"
                      >Rastrear</a
                      >
                      <span v-if="!pedido.trackingLink">Sem Registro</span>

                      <v-tooltip bottom v-if="pedido && pedido.etiquetaId">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              @click="showModalTrackingLink()"
                              v-bind="attrs"
                              v-on="on"
                              icon
                          >
                            <v-icon size="23" color="#BC0000">mdi-pencil-box-outline</v-icon>
                          </v-btn>
                        </template>
                        <span v-if="pedido && pedido.trackingLink">Editar link de rastreio</span>
                        <span v-else>Cadastrar link de rastreio</span>
                      </v-tooltip>
                    </td>
                  </tr>

                  <tr>
                    <td class="informacoes-cliente">Chave de acesso da nota fiscal</td>
                    <td class="informacoes-cliente-dados float-right">
                      <div v-if="pedido && pedido.electronicInvoiceKey" class="d-flex">
                        <span class="mt-2">{{pedido.electronicInvoiceKey}}</span>
                        <v-tooltip bottom >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="copyElectronicInvoiceKey(pedido.electronicInvoiceKey)"
                                v-bind="attrs"
                                v-on="on"
                                icon
                            >
                              <v-icon size="23" color="#BC0000">mdi-content-copy</v-icon>
                            </v-btn>
                          </template>
                          <span>Copiar chave de acesso da nota fiscal</span>
                        </v-tooltip>
                      </div>
                      <span v-else>Sem Registro</span>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <br />
          </v-card>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
          <v-card class="cards ma-0 pa-0 pc-0" height="100%">
            <div class="span-title pa-0 ma-0 px-5 py-2">Pagamento</div>
            <div
              v-if="pedido.paymentMethod === bankSlip"
              class="ma-0 pa-0 py-5"
            >
              <div style="display: inline-flex; text-align: end">
                <v-img
                  class="mx-2"
                  src="../../../assets/boleto.svg"
                  width="70"
                  height="50"
                  alt="boleto"
                  title="boleto"
                >
                </v-img>
                <h3>
                  {{
                    (pedido.fretePrice + pedido.totalPrice).toLocaleString(
                      "pt-br",
                      { style: "currency", currency: "BRL" }
                    )
                  }}
                </h3>
              </div>
              <div class="mx-3" v-if="pedido.orderStatus !== pedidoCancelado">
                <a class="text-left" :href="pedido.urlBoleto" target="_blank">
                  Acessar boleto
                </a>
              </div>
            </div>

            <div
              v-else-if="pedido.paymentMethod === pix"
              class="ma-0 pa-0 py-5"
            >
              <div style="display: inline-flex; text-align: end">
                <v-img
                  class="mx-2"
                  src="../../../assets/pix-icon.svg"
                  width="30"
                  height="30"
                  alt="boleto"
                  title="boleto"
                >
                </v-img>
                <h3>
                  {{
                    (pedido.fretePrice + pedido.totalPrice).toLocaleString(
                      "pt-br",
                      { style: "currency", currency: "BRL" }
                    )
                  }}
                </h3>
              </div>
              <div class="mx-3" v-if="showQrCodePix()">
                <a
                  class="text-left"
                  :href="pedido.qrCodeUrlPix"
                  target="_blank"
                >
                  Acessar Qr code
                </a>
              </div>

              <div
                v-if="showQrCodePix()"
                class="content_copy_qrcode mx-3"
                @click="copyQrcode('qrCodePix')"
              >
                <p style="text-align: left" class="">Copiar Qr Code</p>
                <p id="qrCodePix">{{ pedido.qrCodePix }}</p>
                <img
                  width="22"
                  height="22"
                  class="copy_qrcode"
                  src="../../../assets/copSolid.svg"
                />
              </div>
            </div>

            <div
              v-else
              style="
                display: flex;
                flex-wrap: wrap;
                text-align: start;
                padding-top: 10px;
              "
            >
              <div style="padding-right: 10px" class="px-5">
                <v-img
                  v-if="pedido.brandCard"
                  v-bind:src="
                    require('../../../assets/' + pedido.brandCard + '.svg')
                  "
                  width="50"
                  height="39"
                  :alt="pedido.brandCard"
                  :title="pedido.brandCard"
                ></v-img>
                <p
                  style="text-align: center; font-size: 12px; font-weight: bold"
                >
                  {{ pedido.brandCard }}
                </p>
              </div>

              <div class="dados-pagamento">
                {{ pedido.numberCardFlags }}
                <div>
                  {{
                    (pedido.totalPrice + pedido.fretePrice + pedido.installmentsInterest).toLocaleString(
                      "pt-br",
                      { style: "currency", currency: "BRL" }
                    )
                  }}
                  em
                  {{
                    this.pedido.creditInstallments
                      ? this.pedido.creditInstallments
                      : "1"
                  }}x
                </div>
              </div>
            </div>

            <div class="mx-3">
              <div class="d-flex justify-space-between">
                <span>
                  Status: <b>{{ statusPagamento() }}</b>
                </span>

                <span>
                  Cupom:
                  <b>{{ pedido.coupon ? pedido.coupon.code : currentClient.type === userTypeInstaller ? "DESCONTO-APLICADOR" : "Nenhum" }}</b>
                </span>
              </div>

              <div class="d-flex justify-space-between">
                <span>
                  Desconto:
                  <b>{{
                    pedido.discount
                      ? pedido.discount.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "Nenhum"
                  }}</b>
                </span>
                <span>
                  Frete:
                  <b>{{
                    pedido.fretePrice
                      ? pedido.fretePrice.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "Sem registro"
                  }}</b>
                </span>
              </div>

              <div class="d-flex justify-space-between">
                <span>
                  Forma de envio:
                  <b>{{
                    pedido.deliveryMethod != null
                      ? deliveryMethods[pedido.deliveryMethod]
                      : "Sem registro"
                  }}</b>
                </span>

                <span>
                  Prazo entrega:
                  <b>{{
                    pedido.prazoEntrega
                      ? `${pedido.prazoEntrega} dias`
                      : "Sem registro"
                  }}</b>
                </span>
              </div>

              <div class="d-flex justify-start">
                <span>
                  Enviar por:
                  <b
                      v-if="(freightQuotation && freightQuotation.company && freightQuotation.company.name) || (freightQuotation && freightQuotation.name)"
                  >
                    {{ freightQuotation && freightQuotation.name ? freightQuotation && freightQuotation.name : ''}}
                    {{ freightQuotation && freightQuotation.company && freightQuotation.company.name ? freightQuotation.company.name : ''}}
                  </b>
                  <b v-else>-</b>
                </span>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Linha 3 -->
      <v-row class="cards ma-0 pa-0">
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <v-card class="cards ma-0 pa-0">
            <div class="span-title pa-0 ma-0 px-5 py-2">Itens comprados</div>
            <v-data-table
              ref="table"
              :loading="loading"
              loading-text="Carregando..."
              no-data-text="Nenhum pedido encontrado"
              :headers="headers"
              :items="order"
              class="elevation-1"
              hide-default-footer
              :items-per-page="pageSize"
              :header-props="headerProps"
              :key="componentKey"
            >
              <template v-slot:[`item.productSku`]="{ item }">
                {{ item.productSku.attributes[0].name }}
              </template>


              <template v-slot:[`item.price`]="{ item }">
                {{
                  item.price.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </template>

              <template v-slot:[`item.priceOriginal`]="{ item }">
                {{
                  item.productSku.differentValue.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </template>

              <template v-slot:[`item.sub`]="{ item }">
                {{
                  (item.qty * item.productSku.differentValue).toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                {{
                  (item.qty * item.price).toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </template>
            </v-data-table>
          </v-card>
        </v-col>

        <v-col
            cols="12"
            xs="12"
            sm="12"
            :md="pedido.postageAddress ? 6 : 12"
            :lg="pedido.postageAddress ? 6 : 12"
            :xl="pedido.postageAddress ? 6 : 12"
            v-if="pedido.postageAddress"
        >
          <v-card class="cards ma-0 pa-0" height="270">
            <div class="span-title pa-0 ma-0 px-5 py-2">
              Endereço para postagem
            </div>
            <p class="postageAddress pa-2">{{ pedido.postageAddress }}</p>
            <br />
          </v-card>
        </v-col>

        <v-col
            cols="12"
            xs="12"
            sm="12"
            :md="pedido.postageAddress ? 6 : 12"
            :lg="pedido.postageAddress ? 6 : 12"
            :xl="pedido.postageAddress ? 6 : 12"
        >
          <v-card class="cards ma-0 pa-0">
            <div class="span-title pa-0 ma-0 py-2 px-5">Avaliação do cliente</div>
            <div v-if="pedido && pedido.review" class="pl-5 pb-3">
              <div class="mt-3">
                <label class="mt-2"><strong>Nota para o pedido</strong></label>
                <v-rating
                    v-model="pedido.review.note"
                    bg-color="orange-lighten-1"
                    color="normalred"
                    class="mt-2"
                    readonly
                ></v-rating>
              </div>
              <div class="mt-3">
                <strong>Comentário</strong>
                <p class="mt-3 mb-3">
                  {{pedido.review.evaluation ? pedido.review.evaluation : 'Sem comentário.'}}
                </p>
              </div>
            </div>
            <div class="pl-5 " v-else>
              <p class="my-3">O cliente ainda não avaliou o pedido!</p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-row>

    <v-row
        class="ma-0 pa-5 py-2"
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
    >
      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-card class="cards ma-0 pa-0">
          <div class="span-title pa-0 ma-0 py-2 px-5">Descrição do status da transação</div>
          <p class="postageAddress ml-5 mt-2">{{pedido.transactionMessage && pedido.transactionMessage.length > 0? pedido.transactionMessage : '-'}}</p>
          <br/>
        </v-card>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-card class="cards ma-0 pa-0">
          <div class="span-title pa-0 ma-0 py-2 px-5">Motivo do cancelamento</div>
          <p class="postageAddress ml-5 mt-2">{{pedido.descriptionOfCancellation && pedido.descriptionOfCancellation.length > 0? pedido.descriptionOfCancellation : '-'}}</p>
          <br/>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog DETAILS  -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="detailsDialog"
      max-width="900px"
    >
      <DetailsResale
        title="Detalhar Revenda"
        :resale="this.currentResale"
        @action="detailsDialog = false"
        @close="detailsDialog = false"
        @closeNoLoading="detailsDialog = false"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="enviarDialog" max-width="450px">
      <EnviadoStatusModal
          :order="pedido"
          @close="enviarDialog = false"
          @action="recebenDados"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="entregarDialog" max-width="500px">
      <ConfirmModal
          textMessage="Você confirma a entrega e o recebimento desse pedido?"
          textObservation1="Certifique-se que o status selecionado está correto pois ao mudar não é possível voltar atrás"
          cancelBtn="Cancelar"
          okbtn="Confirmar"
          :order="pedido"
          @close="entregarDialog = false"
          @action="
          ((entregarDialog = false), (pedido.orderStatus = 8)), editStatus()
        "
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
      />
    </v-dialog>

    <!-- inserir codigo de postagem Dialog-->
    <v-dialog v-model="inserirCodigoPostagemDialog" max-width="500px">
      <v-card class="card pa-6 mx-auto" elevation="1">
        <div
            class="px-2 d-flex"
            style="justify-content: center; text-align: center"
        >
          <h2 class="justify-center">
            <span>Insira o Codigo de postagem</span>
          </h2>
        </div>
        <v-form ref="firstForm">
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-text-field
                dense
                outlined
                placeholder="Digite o código de postagem"
                v-model="trackingCode"
                required
            />
          </v-col>
        </v-form>
        <div>
          <v-row class="d-flex ma-0 pa-0" cols="12">
            <v-col cols="12" class="d-flex justify-center">
              <v-btn
                  width="50%"
                  outlined
                  class="cancelBtn mr-2"
                  @click="inserirCodigoPostagemDialog = false"
              >
                <span class="cancel">Cancelar</span>
              </v-btn>

              <v-btn :disabled="!trackingCode" width="50%" color="primary" class="okBtn mr-2" @click="addTrackingCode()">
                <span class="yep">Confirmar</span>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>

    <!-- atualiza/cadastra link de rastreio Dialog-->
    <v-dialog v-model="alterarLinkRastreioDialog" max-width="700px">
      <v-card class="pa-6" elevation="1">
        <div
            class="px-2 d-flex"
            style="justify-content: center; text-align: center"
        >
          <h2 class="justify-center">
            <span v-if="pedido && pedido.trackingLink">Editar link de rastreio</span>
            <span v-else >Cadastrar link de rastreio</span>
          </h2>
        </div>

        <v-form class="pa-0 ma-0 mt-3" ref="firstForm">
          <v-text-field
              dense
              outlined
              full-width
              style="width: 100%!important;"
              placeholder="Digite o código de postagem"
              v-model="trackingLink"
              required
          ></v-text-field>
        </v-form>

        <v-col cols="12" class="d-flex justify-space-between ma-0 pa-0  ">
          <v-btn
              width="48%"
              outlined
              class="cancelBtn mr-3"
              @click="alterarLinkRastreioDialog = false"
          >
            <span class="cancel">Cancelar</span>
          </v-btn>

          <v-btn :disabled="!trackingLink" width="50%" color="primary" class="okBtn mr-2" @click="updateTrackingLink()">
            <span class="yep">Confirmar</span>
          </v-btn>
        </v-col>
      </v-card>
    </v-dialog>

    <!-- imprimir etiquetar Dialog-->
    <v-dialog v-model="imprimirEtiquetaDialog" max-width="700px">
      <v-card class="pa-6" elevation="1">
        <div
            class="px-2 d-flex"
            style="justify-content: center; text-align: center"
        >
          <h2 class="justify-center">
            <span >Opções para imprimir etiqueta</span>
          </h2>
        </div>

        <v-row cols="12" class="mt-3">
          <v-col cols="12">
            <a class="link-etiquette" v-if="pedido && pedido.linkToPrintLabel" :href="pedido.linkToPrintLabel" target="_blank">
              <p>Clique aqui para baixar direto no site do melhor envio</p>
            </a>

            <div v-if="etiquettesFormatJpeg && etiquettesFormatJpeg.length > 0">
              <v-divider></v-divider>
              <ol style="margin-left: -10px">
                <li
                    v-for="(etiquette, index) in etiquettesFormatJpeg"
                    :key="`${etiquette.jpeg}_${index}`"
                >
                  <a
                      :href="etiquette.jpeg"
                      target="_blank"
                      class="link-etiquette"
                  >
                    <span>Clique aqui para baixar imagem da etiqueta {{etiquette.label}}</span>
                  </a>
                </li>
              </ol>
            </div>

            <div class="mt-4" v-if="etiquettesFormatPdf && etiquettesFormatPdf.length > 0">
              <v-divider></v-divider>
              <ol style="margin-left: -10px">
                <li
                    v-for="(etiquette, index) in etiquettesFormatPdf"
                    :key="`${index}`"
                >
                  <a
                      @click="downloadEtiquettePdf(etiquette)"
                      class="link-etiquette"
                  >
                    <span>Clique aqui para baixar o pdf da etiqueta {{etiquette.label}}</span>
                  </a>
                </li>
              </ol>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <!--Cancelar Dialog-->
    <v-dialog v-model="cancelareDialog" max-width="900px">
      <CancelarStatusModal
          :order="pedido"
          @close="cancelareDialog = false"
          @action="dadosCancelamento"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
      />
    </v-dialog>

    <!--Devolver Dialog-->
    <v-dialog v-model="devolverDialog" max-width="450px">
      <ChangeStatusModal
          :title="'Devolver'"
          :order="pedido"
          @close="devolverDialog = false"
          @action="setStatusDevelverPedido()"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
      />
    </v-dialog>

    <!-- Separação Dialog  -->
    <v-dialog v-model="separarDialog" max-width="500px">
      <ConfirmModal
          textMessage="Você confirma que o pedido vai ser separado?"
          textObservation1="Certifique-se que o status selecionado está correto pois ao mudar não é possível voltar atrás"
          cancelBtn="Cancelar"
          okbtn="Confirmar"
          :order="pedido"
          @close="separarDialog = false"
          @action="
          ((separarDialog = false), (pedido.orderStatus = 6)), editStatus()
        "
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
      />
    </v-dialog>
  </v-main>
</template>

<style scoped>
.link-etiquette{
  color: #bc0000;
  text-decoration: none;
  font-size: 16px;
}
.link-etiquette:hover{
  text-decoration: underline;
}
.icon_whatsapp:hover {
  transform: scale(1.2);
}
.content_copy_qrcode {
  margin-top: 10px;
  height: 20px !important;
  cursor: pointer;
  display: flex;
  align-items: start;
}

#qrCodePix {
  display: none;
}
.copy_qrcode {
  margin-left: 5px !important;
  margin-top: -3px;
}
.revendedor-sem-foto {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #dadada;
  border-radius: 20px;
  width: 170px;
  height: 127px;
}
.text-revendedor-foto {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
  text-align: center;
}
.total-pago {
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  color: #000000;
}

.total-pago-dados {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #000000;
  text-align: right;
}

.resale-endereco {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #5f6368;
}

.resale-name {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  color: #000000;
}

.dados-pagamento {
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  color: #000000;
  padding-left: 10px;
}

.informacoes-cliente-dados {
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  color: #000000;
  text-align: right;
}

.informacoes-cliente {
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  color: #000000;
}

.pedido-numero {
  font-style: normal;
  font-weight: 300;
  font-size: 30px;
  line-height: 35px;
  color: #000000;
}

.timeline {
  margin-top: 20px;
  list-style-type: none;
  display: flex;
  text-align: center;

  overflow-x: scroll;
  overflow-y: hidden;
}

.timeline li {
  transition: all 200ms ease-in;
}

.timeline::-webkit-scrollbar {
  width: 12px !important;
  height: 10px !important;
}

.timeline::-webkit-scrollbar-track {
  background: #ffffff;
}

.timeline::-webkit-scrollbar-thumb {
  background: #fede04;
  border-radius: 10px;
}

.timestamp {
  width: 180px;
  margin-bottom: 15px;
  padding: 0px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 50;
}

.status {
  flex-direction: column;
  padding: 0px 10px;
  display: flex;
  text-align: center;
  justify-content: center;
  border-top: 2px solid #eceef1;
  position: relative;
  transition: all 200ms ease-in;
}

.date {
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  color: #979797;
}

.status-title {
  margin-top: 10px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #000000;
}

.status span:before {
  content: "";
  width: 17px;
  height: 17px;
  background-color: #fede04;
  border-radius: 17px;
  position: absolute;
  top: -9px;
  left: 42%;
  transition: all 200ms ease-in;
}

.swiper-control {
  text-align: right;
}

.swiper-container {
  width: 100%;
  margin: 0%;
  padding: 0 20px 30px 20px;
}

.swiper-slide {
  width: 160px;
  text-align: center;
  font-size: 18px;
  margin-top: 10px;
}


/* ANTIGO */
.red-button {
  background-color: transparent !important;
  color: #bc0000 !important;
  border: 2px solid #bc0000 !important;
  box-sizing: border-box !important;
  border-radius: 8px !important;
  margin-top: 20px;
}

.red-button:hover {
  background-color: #bc0000 !important;
  color: #ffffff !important;
}

.red-button:active {
  background-color: #921616 !important;
  color: #ffffff !important;
  border: 2px solid #921616 !important;
}

.image-container {
  /*background: #dadada !important;*/
  border-radius: 20px !important;
}

.transp-button {
  border: 1px solid #979797 !important;
  box-sizing: border-box !important;
  border-radius: 8px !important;

  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: 300 !important;
  font-size: 13px !important;
  height: 46px !important;
  line-height: 69.69% !important;
  background: #ffffff !important;
  color: #979797 !important;
  letter-spacing: 0.15px !important;
}

.text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 22px;
  line-height: 0px;

  letter-spacing: 0.15px;

  color: #2d3038;
}

.cards-small {
  height: 300px !important;
  border-radius: 8px;
}

.label-right {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 32px;
  color: #e30011;
}

.span-title {
  background-color: #eceef1 !important;
  font-family: Poppins !important;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 22px;
  color: #2d3038;
}

.mainCheckout {
  padding: 0px !important;
  max-width: unset !important;
  background-color: #f5f5f5;
}

@media (max-width: 600px) {
  .text {
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 0.2px;

    letter-spacing: 0.15px;

    color: #2d3038;
  }
}

/*@media (max-width: 1210px) and (min-width: 600px) {
  .revendedor {
    flex-wrap: wrap;
  }
  .altura{
    height: auto;
    min-height: 205px;
  }
}*/
</style>

<script>
import ApiService from "../../../services/ApiService";
import DetailsResale from "../Resales/components/DetailsResale.vue";

import Vue from "vue";
import Utils from "../../../Utils/FormatDate";
import moment from "moment";
import EnviadoStatusModal from "@/views/pages/components/EnviadoStatusModal.vue";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import CancelarStatusModal from "../components/CancelarStatusModal.vue";
import ChangeStatusModal from "../components/ChangeStatusModal.vue";
export default {
  name: "OrderStatus",

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

  components: {
    ChangeStatusModal,
    CancelarStatusModal,
    ConfirmModal,
    EnviadoStatusModal,
    DetailsResale,
  },

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },

  data: () => ({
    deliveryMethods: ["Receber", "Buscar na loja"],
    pedidoAprovado: 3,
    pedidoReprovado: 2,
    pedidoSeparando: 6,
    pedidoEnviado: 4,
    pedidoAguardando: 1,
    pedidoEntregue: 8,
    pedidoDevolvido: 5,
    pedidoCancelado: 7,
    bankSlip: 1,
    pix: 2,
    breadcrumbs: 0,
    componentKey: 0,
    dialogKey: 1,
    detailsDialog: false,
    devolverDialog: false,
    inserirCodigoPostagemDialog: false,
    alterarLinkRastreioDialog: false,
    imprimirEtiquetaDialog: false,
    etiquettesFormatPdf: [],
    etiquettesFormatJpeg: [],
    gerarEtiquetaDialog: false,
    trackingCode: null,
    trackingLink: null,
    currentResale: [],
    discount: 0.0,
    frete: [],
    endereco: [],
    currentClient: [],
    userTypeInstaller: 3,
    apiService: new ApiService(),
    enviarDialog: false,
    separarDialog: false,
    entregarDialog: false,
    closeNoLoading: false,
    cancelareDialog: false,
    descriptionOfCancellation: null,
    freightQuotation: null,
    refundTotal: 0,
    pedido: {
      totalPrice: 0,
      discount: 0,
      fretePrice: 0,
      brandCard: "Mastercard",
    },
    descount: 10,
    order: [],
    itemsCancelled: [],
    isMobile: false,
    src: "",
    page: 1,
    totalPages: 1,
    pageSize: 100000,
    loading: false,
    steps: [],
    headers: [
      {
        text: "Código",
        class: "item",
        value: "product.productCode",
        align: "center",
        sortable: false,
      },
      {
        text: "SKU",
        class: "item",
        value: "productSku",
        align: "center",
        sortable: false,
      },
      {
        text: "Produto",
        class: "item",
        value: "product.productName",
        align: "center",
        sortable: false,
      },
      {
        text: "Preço na plataforma",
        class: "item",
        value: "priceOriginal",
        align: "center",
        sortable: false,
      },
      {
        text: "Preço no pedido",
        class: "item",
        value: "price",
        align: "center",
        sortable: false,
      },
      {
        text: "Quantidade",
        class: "item",
        value: "qty",
        align: "center",
        sortable: false,
      },
      {
        text: "Subtotal",
        class: "item",
        value: "sub",
        align: "center",
        sortable: false,
      },
      {
        text: "Total",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    headersCancelled: [
      {
        text: "Código",
        class: "item",
        value: "product.productCode",
        align: "center",
        sortable: false,
      },
      {
        text: "SKU",
        class: "item",
        value: "productSku",
        align: "center",
        sortable: false,
      },
      {
        text: "Produto",
        class: "item",
        value: "product.productName",
        align: "center",
        sortable: false,
      },
      {
        text: "Preço na plataforma",
        class: "item",
        value: "priceOriginal",
        align: "center",
        sortable: false,
      },
      {
        text: "Preço no pedido",
        class: "item",
        value: "price",
        align: "center",
        sortable: false,
      },
      {
        text: "Quantidade",
        class: "item",
        value: "qty",
        align: "center",
        sortable: false,
      },
      {
        text: "Subtotal",
        class: "item",
        value: "sub",
        align: "center",
        sortable: false,
      },
      {
        text: "Total",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
      {
        text: "Data do cancelamento",
        class: "item",
        value: "refundDate",
        align: "center",
        sortable: false,
      },
    ],
    headerProps: { sortByText: "Ordenar por" },
  }),

  watch: {
    calculateDiscount(item) {
      this.discount = item.finalPrice / 10;
      this.componentKey += 1;
    },
  },

  computed: {},

  async created() {
    this.breadcrumbs = this.$route.query.breadcrumbs;
    await this.getOrderById();
  },

  methods: {
    formatDate(date) {
      return Utils.moment(date);
    },
    async dadosCancelamento(dados) {
      this.pedido.orderStatus = 7;
      this.cancelareDialog = false;
      this.descriptionOfCancellation = dados.descriptionOfCancellation;
      this.pedido.DescriptionOfCancellation = dados.descriptionOfCancellation;
      this.pedido.refundAmount = 0;
      this.pedido.refundType = dados.refundType;
      this.pedido.reasonForCancellation = dados.reasonForCancellation;
      if(this.pedido.refundType == this.refundTotal){
        await this.editStatus();
        return
      }
      this.pedido.refundAmount = dados.refundAmount;
      this.pedido.items = dados.items;

      await this.partiallyCancel()
    },
    async showModalTrackingLink() {
      this.alterarLinkRastreioDialog = true;
      this.trackingLink = this.pedido.trackingLink
    },
    async updateTrackingLink() {
      this.alterarLinkRastreioDialog = false;
      this.loading = true;
       const body = {
         trackingLink: this.trackingLink
       }
      await this.apiService
        .put(`order/trackingLink/${this.pedido.id}`, body)
        .then(async (resp) => {
          await this.getOrderById();
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Sucesso",
            message: resp.message
              ? resp.message
              : "Link de rastreio atualizado com sucesso!",
            trace: null,
          });
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro",
            message: erro.body
              ? erro.body.message
              : "Não foi possível atualizar o link de rastreio",
            trace: null,
          });
        });
    },
    downloadEtiquettePdf(etiquette){
      try {
        const excel =  `data:application/octet-stream;base64,${etiquette.pdf}`
        const link = document.createElement("a");
        link.href = excel;
        link.setAttribute("download", `${etiquette.label}.pdf`);
        document.body.appendChild(link);
        link.click();
      } catch (e) {

      }
    },
    async convertPdfToBase64(url) {
      const {statusCode, content} = await this.apiService.post(`order/urlFileToBase64`, {url})
      return statusCode === 200 && content ? content : null
    },
    hasEtiquetteFile(file) {
      return !!(file && (file['jpeg'] || file['pdf']))
    },
    async addEtiquetteFile(file, label) {
      const {jpeg, pdf} = file
      if (jpeg) {
        this.etiquettesFormatJpeg.push({jpeg, label})
      }
      if (pdf) {
        const content = await this.convertPdfToBase64(pdf)
        if (content) {
          this.etiquettesFormatPdf.push({pdf: content, label})
        }
      }
    },
    async collectEtiquetteFiles(files, buildLabel) {
      let count = 1
      while (this.hasEtiquetteFile(files[count])) {
        await this.addEtiquetteFile(files[count], buildLabel(count))
        count++
      }
    },
    async getEtiquettesByShippingLabels() {
      let index = 1
      await this.apiService
          .get(`order/etiquette/${this.pedido.id}`)
          .then(async (response) => {
            const {content: etiquettes} = response
            for (const etiquette of etiquettes) {
              if (etiquette) {
                const label = `do pacote ${index.toString().padStart('4', '0')}/${etiquettes.length.toString().padStart('4', '0')}`
                await this.collectEtiquetteFiles(etiquette.files, () => label)
                index++
              }
            }
          })
          .catch(() => {
            this.imprimirEtiquetaDialog = true
          })
    },
    async getEtiquettesLegacy() {
      await this.apiService
          .get(`order/etiquette/${this.pedido.id}`)
          .then(async (response) => {
            const {content} = response
            if (content) {
              const totalFiles = Object.keys(content.files).length
              await this.collectEtiquetteFiles(content.files, (count) =>
                  `do pacote ${count.toString().padStart('4', '0')}/${totalFiles.toString().padStart('4', '0')}`)
            }
            this.imprimirEtiquetaDialog = true
          })
          .catch(() => {
            this.imprimirEtiquetaDialog = true
          })
    },
    async getEtiquette() {
      try {
        this.etiquettesFormatJpeg = []
        this.etiquettesFormatPdf = []

        if (this.pedido.shippingLabels && this.pedido.shippingLabels.length > 0) {
          await this.getEtiquettesByShippingLabels()
          this.imprimirEtiquetaDialog = true
          return
        }
        await this.getEtiquettesLegacy()
      } catch (e) {
        this.imprimirEtiquetaDialog = true
      }
    },
    async addTrackingCode() {
      this.pedido.trackingCode = this.trackingCode;
      this.inserirCodigoPostagemDialog = false;
      await this.apiService
          .put(`order/tracking-code`, this.pedido)
          .then(async (resp) => {
            await this.getOrderById();
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Sucesso",
              message: resp.message
                  ? resp.message
                  : "Mudança de status efetuada!",
              trace: null,
            });
          })
          .catch((erro) => {
            this.loading = false;
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro",
              message: erro.body
                  ? erro.body.message
                  : "Não foi possível adicionar o código de rastreio",
              trace: null,
            });
          });
    },
    disabled(status) {
      return !!this.pedido.orderStatusList.find((x) => x.status === status);
    },
    async recebenDados(item) {
      this.pedido.orderStatus = 4;
      this.enviarDialog = false;
      this.trackingCode = item.trackingCode;
      this.companyName = item.companyName;
      this.trackingLink = item.trackingLink;

      this.pedido.TrackingCode = item.trackingCode;
      this.pedido.CompanyName = item.companyName;
      this.pedido.TrackingLink = item.trackingLink;
      await this.editStatus();
    },

    setStatusDevelverPedido(){
      this.devolverDialog = false
      this.pedido.orderStatus = this.pedidoDevolvido
      this.editStatus()
    },
    async editStatus() {
      this.loading = true;
      await this.apiService
          .post(`order/changestatus`, this.pedido)
          .then((resp) => {
            this.getOrderById();
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Sucesso",
              message: resp.message
                  ? resp.message
                  : "Mudança de status efetuada!",
              trace: null,
            });
          })
          .catch((erro) => {
            this.loading = false;
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro",
              message: erro.body
                  ? erro.body.message
                  : "Não foi possível alterar status do pedido",
              trace: null,
            });
          });
    },
    async partiallyCancel() {
      this.loading = true;
      this.agenciasDialog = false;
      await this.apiService
          .post(`order/cancel-partially`, this.pedido)
          .then((resp) => {
            this.getOrderById();
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Sucesso",
              message: resp.message
                  ? resp.message
                  : "Mudança de status efetuada!",
              trace: null,
            });
          })
          .catch((erro) => {
            this.loading = false;
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro",
              message: erro.body
                  ? erro.body.message
                  : "Não foi possível alterar status do pedido",
              trace: null,
            });
          });
    },
    excel() {
      this.apiService.get(`order/excel/${this.pedido.id}`).then((response) => {
        const excel =
          "data:application/octet-stream;base64," + response.content;
        const link = document.createElement("a");
        link.href = excel;
        link.setAttribute("download", `pedido.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    },

    async copyQrcode(id) {
      const content = document.getElementById(id).innerHTML;
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard
          .writeText(content)
          .then(() => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "",
              message: "Qr Code copiado.",
              trace: null,
            });
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Não foi possível copiar o Qr Code",
              trace: null,
            });
          });
      }
    },

    async copyElectronicInvoiceKey(electronicInvoiceKey) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard
          .writeText(electronicInvoiceKey)
          .then(() => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "",
              message: "Chave de acesso da nota fiscal copiada.",
              trace: null,
            });
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Não foi possível copiar a chave de acesso da nota fiscal!",
              trace: null,
            });
          });
      }
    },

    showQrCodePix() {
      return (
        moment(new Date(this.pedido.currentDate)).isBefore(
          new Date(this.pedido.expiresInQrCodeUrlPix)
        ) &&
        !this.pedido.orderStatusList.find(
          (step) => step.status === this.pedidoAprovado
        )
      );
    },
    statusPagamento() {
      if (this.steps.find((step) => step.status === this.pedidoAprovado)) {
        return "Pago";
      } else if (
        this.steps.find((step) => step.status === this.pedidoAguardando)
      ) {
        if (
          this.pedido.orderStatus === this.pedidoCancelado &&
          this.pedido.paymentMethod === this.bankSlip
        ) {
          return "Boleto expirado";
        } else if (
          moment(new Date(this.pedido.currentDate)).isAfter(
            new Date(this.pedido.expiresInQrCodeUrlPix)
          ) &&
          this.pedido.paymentMethod === this.pix
        ) {
          return "Qr Code expirado";
        }
        return "Pendente";
      } else if (
        this.steps.find((step) => step.status === this.pedidoReprovado)
      ) {
        return "Pagamento recusado";
      }
    },
    calculateSubtotal() {
      return this.pedido.totalPrice + this.pedido.fretePrice + this.pedido.installmentsInterest
    },
    showPhoto(image) {
      if (!!image && image.includes("Uploads/")) {
        const env_url = process.env.VUE_APP_BASE_URL;
        return env_url + image;
      } else {
        return image;
      }
    },

    calculateTotal() {
      let total = 0;
      this.order.forEach((e) => {
        total = total + e.price * e.qty;
      });
      total = total - this.discount + parseFloat(this.valorFrete);
      this.total = total;
      this.componentKey += 1;
    },

    fillOrderStatusList(listOrder) {
      this.steps = []
      listOrder.forEach((x) => {
        switch (x.status) {
          case 0:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Novo`,
              status: x.status,
            });
            break;
          case 1:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Aguardando`,
              status: x.status,
            });
            break;
          case 2:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Reprovado`,
              status: x.status,
            });
            break;
          case 3:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Aprovado`,
              status: x.status,
            });
            break;
          case 4:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Enviado`,
              status: x.status,
            });
            break;
          case 5:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Devolvido`,
              status: x.status,
            });
            break;
          case 6:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Separando`,
              status: x.status,
            });
            break;
          case 7:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Cancelado`,
              status: x.status,
            });
            break;
          case 8:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Entregue`,
              status: x.status,
            });
            break;
          case 9:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Retirar`,
              status: x.status,
            });
            break;
          case 11:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Cancelado parcialmente`,
              status: x.status,
            });
            break;
          default:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Etiqueta`,
              status: x.status,
            });
        }
      });
    },

    async getOrderById() {
      this.loading = true;
      await this.apiService
        .get(`order/get-one?id=` + this.$route.query.id)
        .then((response) => {
          this.pedido = response[0];
          this.freightQuotation = JSON.parse(this.pedido.freightQuotation)
          this.order = this.pedido.items;
          this.itemsCancelled = this.pedido.items.filter(x => x.refundDate);
          this.frete.valor = this.pedido.fretePrice;
          this.fillOrderStatusList(response[0].orderStatusList);
          this.getClientbyId(this.pedido.clientId);
          this.getAddressbyId(this.pedido.deliveryId);
          this.getResalebyId(this.pedido.resaleId);
          this.calculateTotal();
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro ao buscar este pedido!",
            message: "Erro ao buscar este pedido!",
            trace: null,
          });
        });

      this.loading = false;
    },

    async getAddressbyId(id) {
      this.loading = true;
      await this.apiService
        .get(`order/get-address?id=` + id)
        .then((response) => {
          this.endereco = response[0];
          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro ao buscar endereço!",
            message: "Erro ao buscar endereço!",
            trace: null,
          });
          this.loading = false;
        });
    },
    async getClientbyId(id) {
      this.loading = true;
      await this.apiService
        .get(`user/get-one?id=` + id)
        .then((response) => {
          this.currentClient = response;
          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro ao buscar cliente!",
            message: "Erro ao buscar cliente!",
            trace: null,
          });
          this.loading = false;
        });
    },
    // TODO: colocar o resaleId certo calculado pelo vagueta
    async getResalebyId(id) {
      this.loading = true;
      await this.apiService
        .get(`user/get-one?id=` + id)
        .then((response) => {
          this.currentResale = response;

          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro ao buscar cliente!",
            message: "Erro ao buscar cliente!",
            trace: null,
          });
          this.loading = false;
        });
    },

    async goToRoute(route) {
      if (this.$route.path != route) {
        await this.$router.push(route);
      }
    },

    onResize() {
      this.isMobile = window.innerWidth < 960;
    },
  },
};
</script>
